module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n\r\n.row:nth-child(odd){\r\n    background: #ececec;\r\n}\r\n\r\n\r\n#cen {\r\n    text-align: center;\r\n    background: #ced7e6;\r\n    font-size: 22px;\r\n}\r\n\r\n\r\ntable, td{\r\n    border: 1px solid #ddd;\r\n}\r\n\r\n\r\n.Green{\r\n    background: #63e673eb;\r\n}\r\n\r\n\r\n.Red{\r\n    background: #e65b6deb;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/allottment-list/allottment-list.component.css
// module id = ./src/app/allocation/allottment-list/allottment-list.component.css
// module chunks = main